(() => {
  const bar = document.querySelector('[data-sticky-buy-bar]');
  if (!bar) return;

  const barButton = bar.querySelector('[data-sticky-buy-bar-button]');
  const barPrice = bar.querySelector('[data-sticky-buy-bar-price]');

  // Scoped til main, så quick-add-modalens knap ikke rammes
  const mainButton = () => document.querySelector('main .add-to-cart-button');

  const mainPrice = () => document.querySelector('main product-price .price');

  const target = mainButton();
  if (!target) return;

  bar.hidden = false;

  // Vis baren når hovedknappen er scrollet forbi (over viewport), skjul ellers
  const observer = new IntersectionObserver(
    ([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.toggleAttribute('data-visible', passed);
    },
    { threshold: 0 }
  );
  observer.observe(target);

  // Proxy-klik: al variant-/kurvlogik bliver i temaets eget product-form
  barButton.addEventListener('click', () => {
    const btn = mainButton();
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    btn.click();
  });

  // Hold pris og knaptilstand synkron med hovedformularen ved variantskift.
  // Skriv kun ved reelle ændringer, ellers trigger observeren sig selv i loop.
  const syncState = () => {
    const priceEl = mainPrice();
    if (priceEl && barPrice) {
      const price = priceEl.textContent.trim();
      if (price && price !== barPrice.textContent) barPrice.textContent = price;
    }
    const btn = mainButton();
    if (btn) {
      const disabled = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
      if (barButton.disabled !== disabled) barButton.disabled = disabled;
      const labelEl = btn.querySelector('.add-to-cart-text__content') || btn;
      const label = labelEl.textContent.trim();
      if (label && label !== barButton.textContent.trim()) barButton.textContent = label;
    }
  };

  syncState();

  const container = document.querySelector('main') || document.body;
  const mo = new MutationObserver((mutations) => {
    if (mutations.some((m) => bar.contains(m.target))) return;
    syncState();
  });
  mo.observe(container, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['disabled', 'aria-disabled'],
  });
})();
